import {Paragraph} from 'evergreen-ui';
import React, {FunctionComponent, memo} from 'react';
import {PlacementType, Referral} from '../domain/types';

type ScopeOfServiceRendererProps = {
    referral: Partial<Referral>;
    textEllipsis?: boolean;
}

export const scopeOfServiceMapping = {
    [PlacementType.Assessment_Only]: 'Assessment Only',
    [PlacementType.Assessment_with_Concurrent_Treatment]: 'Assessment with Concurrent Treatment',
    [PlacementType.Treatment_Only]: 'Treatment Only',
    [PlacementType.Transfer_Reevaluation]: 'Transfer Reevaluation',
}
export const ScopeOfServiceRenderer: FunctionComponent<ScopeOfServiceRendererProps> = memo(({referral, textEllipsis = true}: ScopeOfServiceRendererProps) => {

    if (!!referral.placementType) {
        return (<Paragraph className="portal-ev-tr-td"
                           overflow={"hidden"}
                           whiteSpace={textEllipsis ? "nowrap" : "normal"}
                           textOverflow={textEllipsis ? "ellipsis" : "normal"}
                           size={500}>{scopeOfServiceMapping[referral.placementType]}</Paragraph>);
    } else {
        return 'None';
    }
});
